// extracted by mini-css-extract-plugin
export default {"paper":"paper___wzhvp","basicTable":"basicTable___FYNR3"};